import React, { useState, useEffect } from "react";
import { useAuth } from "../../context/Auth";
import { useLocation } from "react-router-dom";
import styles from "./Hooks.module.css";

const ErrorBoundary = ({ children }) => {
  const [hasError, setHasError] = useState(false);
  const { mode } = useAuth();
  const location = useLocation();

  useEffect(() => {
    setHasError(false);
  }, [location]);

  useEffect(() => {
    const handleGlobalError = (error, errorInfo) => {
      console.error("Uncaught error:", error, errorInfo);
      setHasError(true);
    };

    const errorListener = (event) => {
      handleGlobalError(event.error, event);
    };

    window.addEventListener("error", errorListener);

    return () => {
      window.removeEventListener("error", errorListener);
    };
  }, []);

  if (hasError) {
    return (
      <div
        className={`${styles.error_boundary} ${
          mode ? styles.error_boundary_dark : {}
        }`}
      >
        <h1>&#40;&gt;&#95;&lt;&#41;</h1>
        <p>Something went wrong. Please try again soon.</p>
      </div>
    );
  }

  return children;
};

export default ErrorBoundary;

// // ErrorBoundary.js
// import React, { Component } from 'react';
// import { useAuth  } from '../../context/Auth';

// class ErrorBoundary extends Component {
//   static contextType = useAuth ;

//   constructor(props) {
//     super(props);
//     this.state = { hasError: false };
//   }

//   static getDerivedStateFromError() {
//     // Update state so the next render will show the fallback UI.
//     return { hasError: true };
//   }

//   componentDidCatch(error, errorInfo) {
//     // You can log the error to an error reporting service here
//     console.error("Uncaught error:", error, errorInfo);
//   }

//   render() {
//     const { hasError } = this.state;
//     const { children } = this.props;
//     const { mode } = this.context; // Access context value

//     if (hasError) {
//       // Fallback UI
//       return <div style={{}}>
//         <h1>Something went wrong.</h1>;
//       </div>
//     }

//     return children;
//   }
// }

// export default ErrorBoundary;
